import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { formatUrl } from '@ifeng/public_method';
import styles from './index.css';
import { getImage } from '../../../utils/cutImg';
import { rel as relText } from '../../../utils/rel';
import { classnames } from '../../../utils/classnames';

class NewsGroupComponent extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        componentOptions: PropTypes.object,
    };

    // 判断为视频
    isVideo = item => item.videoCount;
    // 判断为图片
    isImage = item => item.thumbnails && item.thumbnails !== '' && item.thumbnails.image.length > 0;
    // 获取image的url
    getImageUrl(item) {
        if ('picUrl' in item) {
            return item.picUrl;
        } else {
            return item.url;
        }
    }
    newsView(list) {
        let topType = null; // 第一个的类型：video或image
        let topIndex = null; // 第一个的索引

        for (let i = 0, j = list.length; i < j; i++) {
            const item = list[i];

            if (this.isVideo(item) && (topType === null || topType === 'image')) {
                topType = 'video';
                topIndex = i;
            } else if (this.isImage(item) && topType === null) {
                topType = 'image';
                topIndex = i;
            }
        }

        // 排序
        if (topIndex !== null && topIndex > 0) {
            const top = list[topIndex];

            list.splice(topIndex, 1);
            list.unshift(top);
        }

        return list.map((item, index) => {
            const key = item.id;
            const url = formatUrl(item.url);

            // 渲染视频模式
            if (index === 0 && topType === 'video') {
                const { image } = item.thumbnails;

                return (
                    <li key={key} className={`${styles.has_image} clearfix`}>
                        <a className={styles.image_link} href={url} title={item.title} target="_blank" rel={relText}>
                            <img
                                src={image ? getImage(this.getImageUrl(image[0]), 98, 54) : undefined}
                                alt={item.title}
                            />
                            <div className={styles.play} />
                        </a>
                        <h5 className={styles.image_title}>
                            <a href={url} title={item.title} target="_blank" rel={relText}>
                                {item.title}
                            </a>
                        </h5>
                    </li>
                );
            }

            // 渲染图片模式
            if (index === 0 && topType === 'image') {
                const { image } = item.thumbnails;

                return (
                    <li key={key} className={`${styles.has_image} clearfix`}>
                        <a className={styles.image_link} href={url} title={item.title} target="_blank" rel={relText}>
                            <img
                                src={image ? getImage(this.getImageUrl(image[0]), 98, 54) : undefined}
                                alt={item.title}
                            />
                        </a>
                        <h5 className={styles.image_title}>
                            <a href={url} title={item.title} target="_blank" rel={relText}>
                                {item.title}
                            </a>
                        </h5>
                    </li>
                );
            }

            // 无图
            return (
                <li key={key} className={styles.no_image}>
                    <a href={url} title={item.title} target="_blank" rel={relText}>
                        {item.title}
                    </a>
                </li>
            );
        });
    }
    render() {
        const {
            content,
            componentOptions: { infoTitle, infoUrl },
        } = this.props;

        return (
            <div className={styles.news_group}>
                {/* 标题 */}
                <div className={`${styles.news_group_title} clearfix`}>
                    <i className={classnames(styles.block, 'block')} />
                    <span className={styles.link_title}>{infoTitle}</span>
                    {infoUrl ? (
                        <a className={styles.more} href={infoUrl} target="_blank" rel={relText}>
                            更多&gt;
                        </a>
                    ) : null}
                </div>
                {/* 新闻 */}
                <ul className={classnames(styles.news_list, 'news_list')}>{this.newsView(content)}</ul>
            </div>
        );
    }
}

export default errorBoundary(NewsGroupComponent);
